module.exports = __webpack_public_path__ + "media/images/icons/submit_evidence_chevron_black-b9cd98d2233a6f87acb3cfdb315cdef6.svg";